import { useCallback } from 'react';
import { useCheckoutStore, useTranslation } from 'mycheck-core';
import { useIframeMessageListener } from 'core/hooks/useIframeMessageListener';
import { AstralWalletParentMessage } from '../constants';

export const useAstralWalletParentMessageListener = () => {
  const { t } = useTranslation();
  const CheckoutStore = useCheckoutStore();

  const handleToggleAstralWalletLoader = useCallback(() => {
    CheckoutStore.setAstralWalletLoaderLabel(
      t('astralWallet.refundingOrderLoaderLabel'),
    );
    CheckoutStore.toggleAstralWalletLoader();
  }, []);

  useIframeMessageListener<AstralWalletParentMessage>({
    [AstralWalletParentMessage.TOGGLE_ASTRAL_WALLET_LOADER]:
      handleToggleAstralWalletLoader,
  });
};
